var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 90,
    viewBox: "0 0 92 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.22 10.9946L62.1766 6.24886C54.2383 2.08297 50.2691 0 45.9993 0C41.7294 0 37.7603 2.08297 29.8219 6.24886L28.3672 7.01226L68.7145 30.0678L86.8768 20.9867C83.9549 17.6776 79.2406 15.2035 71.22 10.9946Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0786 26.969L71.9991 36.0087V49.7388C71.9991 51.6116 70.4807 53.13 68.6078 53.13C66.7349 53.13 65.2165 51.6116 65.2165 49.7388V39.3999L49.3905 47.3129V90C52.6367 89.1915 56.3305 87.2531 62.1766 84.1851L71.22 79.4396C80.9493 74.3337 85.8138 71.7812 88.515 67.1939C91.2163 62.6066 91.2163 56.898 91.2163 45.4816V44.9525C91.2163 36.3947 91.2163 31.0441 90.0786 26.969Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.608 90V47.3129L1.92007 26.969C0.782227 31.0441 0.782227 36.3947 0.782227 44.9525V45.4816C0.782227 56.898 0.782226 62.6066 3.48349 67.1939C6.18471 71.7812 11.0493 74.3337 20.7785 79.4396L29.8219 84.1851C35.6683 87.2531 39.3619 89.1915 42.608 90Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12166 20.9867L45.9993 41.4256L61.4237 33.7134L21.2409 10.7519L20.7785 10.9946C12.7582 15.2035 8.04363 17.6776 5.12166 20.9867Z",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBox);
export default __webpack_public_path__ + "static/media/openBox.365bff292334ded50beda40678619f45.svg";
export { ForwardRef as ReactComponent };